/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from 'react'
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import { useLocation, Link } from 'react-router-dom';
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { CardText, CardTitle, Card, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { MdLocationOn } from "react-icons/md";
import ReportSuggestionModal from '../../../components/Modals/ReportSuggestionModal';
import ShareModal from '../../../components/Modals/ShareModal';
import SelectRouteModal from '../../../components/Modals/SelectRouteModal';
import PointsListingModal from '../../../components/Modals/PointsListingModal';
import CreateNewRouteModal from '../../../components/Modals/CreateNewRouteModal';
import { routeDetail, updateRouteDetail } from '../../../services/myRoute.service';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import "./mapview.scss";

const containerStyle = {
    width: '100%',
    height: '1050px',
    borderRadius: "50px"
};

const options = {
    minZoom: 2,
    maxZoom: 17,
    gestureHandling: 'greedy'
}

function MapView({ categoryItem, removeFromFavorite, addToFavorite, name, categoryTitle, categoryIcon }) {
    const [icon, setIcon] = useState('');
    const [activeMarker, setActiveMarker] = useState(null);
    const [dropdownMenuOpen, setMenuOpen] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [pointName, setPointName] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showListModal, setShowListModal] = useState(false);
    const [routeName, setRouteName] = useState(null);
    const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [route, setRoute] = useState(null);
    const [mkmID, setMkmId] = useState();
    const [link, setLink] = useState('');
    const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/(null));


    console.log('caaaaaategory', categoryItem)

    const userName = useSelector((state) => state?.userDetailReducer?.userData?.userName);
    const location = useLocation()
    const { categoryName } = location?.state || '';

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8"
    })

    const toggle = () => {
        setShowModal(!showModal);
        setRoute(null);
    };

    const onLoad = useCallback(function callback(map) {
        const bounds = new window.google.maps.LatLngBounds(
          new window.google.maps.LatLng(-90, -180), // South-west map corner
          new window.google.maps.LatLng(90, 180) // North-east map corner
        );
        map?.fitBounds(bounds);
      }, []);

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const createNewRoute = () => {
        setShowModal(false);
        setShowCreateRouteModal(true);
    };

    const addToRoute = (id,item) => {
        setMkmId(id)
        setPointName(item)
        setShowModal(true);
    };

    const share = (id, poi) => {
        var data
        if (name === "Tzadikim") {
            data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id}/${poi}`;
            setLink(data)
        } else {
            data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`
            setLink(data)
        }
        setShowShareModal(true);
    }

    const reportSuggestion = (title, id) => {
        setMkmId(id)
        setPointName(title)
        setShowReportModal(true);
    }

    const selectRoute = async () => {
        let existingData;
        if (route?.id) {
            try {
                let response = await routeDetail({
                    userName: userName,
                    routeID: route?.id
                });
                if (response && response?.status === 200) {
                    existingData = response?.data?.data
                }

                if (existingData?.length >= 25) {
                    toast.warning("Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.", {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 2000
                    });
                    setShowSpinner(false);
                    setRoute('');
                    setShowModal(false);
                    return;
                }
            
                const newPlace = {
                    mkmID: mkmID,
                    orderNumber: existingData.length,
                    visited: false
                };
            
                const updatedRoute = [...existingData, newPlace];
            
                const requestBody = updatedRoute.map((item, i) => ({
                    mkmID: item?.place?.mkmID || item?.mkmID,
                    orderNumber: i,
                    visited: item?.visited
                }));
                try {
                    setShowSpinner(true);
                    let res = await updateRouteDetail(requestBody, {
                        userName: userName,
                        routeID: route?.id,
                    });
                    if (res?.status === 200) {
                        setActiveMarker(null);
                        toast.success("Point Added Successfully In Your Route!", {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000
                        });
                    }
                } catch (err) {
                    toast.error(
                        err?.response?.data?.message || "Oops.. something went wrong, try again !!!",
                        {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 2000,
                        }
                    );
                } finally {
                    setShowSpinner(false);
                    setRoute('');
                    setShowModal(false);
                }
            } catch (error) {
                console.log(error);
                setShowSpinner(false);
            };
        }
        if (!route?.id) {
            toast.error("Please Select The Route.", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            })
            setShowSpinner(false);
        }
    }

    useEffect(() => {
        const iconMap = {
            "Airports": "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            "Cemeteries": "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
            "Food": "http://maps.google.com/mapfiles/ms/icons/purple-dot.png",
            "Historical Places": require('../../../assets/gray.png'),
            "Hotels": "http://maps.google.com/mapfiles/ms/icons/orange-dot.png",
            "Mikvah": "http://maps.google.com/mapfiles/ms/icons/pink-dot.png",
            "Synagogues": "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png",
            "Tzadikim": "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
        };
        setIcon(iconMap[categoryName] || '');
    }, [categoryName]);

    return (
        <div className='map_view' style={{marginBottom: "80px"}}>
            <SelectRouteModal
                route={route}
                setRoute={setRoute}
                showModal={showModal}
                toggle={toggle}
                createNewRoute={createNewRoute}
                selectRoute={selectRoute}
                showSpinner={showSpinner}
            />
            <CreateNewRouteModal
                showCreateRouteModal={showCreateRouteModal}
                setShowCreateRouteModal={setShowCreateRouteModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                routeName={routeName}
                setRouteName={setRouteName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <PointsListingModal
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                setPointName={setPointName}
            />
            <ReportSuggestionModal
                showReportModal={showReportModal}
                setShowReportModal={setShowReportModal}
                showListModal={showListModal}
                setShowListModal={setShowListModal}
                setRouteName={setRouteName}
                routeName={routeName}
                pointName={pointName}
                mkmID={mkmID}
            />
            <ShareModal
                showShareModal={showShareModal}
                setShowShareModal={setShowShareModal}
                link={link}
                setLink={setLink}
            />
            {isLoaded ? (
                <GoogleMap
                    zoom={2}
                    mapContainerStyle={containerStyle}
                    onLoad={onLoad}
                    options={options}
                >
                    {categoryItem?.map(item =>
                        <div key={item?.mkmID}>
                            <Marker
                                // icon={{
                                //     url: icon
                                // }}
                                position={{ lat: Number(item?.poi?.split(",")[0]), lng: Number(item?.poi?.split(",")[1]) }}
                                onClick={() => handleActiveMarker(item?.mkmID)}

                                onLoad={marker => {
                                    const customIcon = (opts) => Object.assign({
                                        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                                        fillColor: '#34495e',
                                        fillOpacity: 1,
                                        strokeColor: 'teal',
                                        strokeWeight: 2,
                                        scale: 1,
                                    }, opts);
                
                                    const colorMap = {
                                        1: '#d2b48c',
                                        10: 'teal',
                                        5: 'turquoise',
                                        4: 'gold',
                                        2: '#000080',
                                        7: '#00ffff',
                                        9: 'tomato',
                                        12: 'wheat'
                                    };
                
                                    const fillColor = colorMap[item?.categotyID] || 'green';
                                    marker.setIcon(customIcon({ fillColor, strokeColor: 'white' }));
                
                                    return handleActiveMarker(marker, item);
                                }}
                            >
                                {activeMarker === item?.mkmID ? (
                                    <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                        <div className="info_window"> <Card body>
                                            <div className="card_header">
                                                {item?.userFavorite === true ? <Button className='favourite_fill_icon' onClick={() => removeFromFavorite(item?.tzadikimID ? { tzadikimID: item?.tzadikimID } : { mkmID: item?.mkmID }, item?.userFavorite)}><AiFillStar size={20} /></Button> :
                                                    <Button className="favourite_icon" onClick={() => addToFavorite(item?.tzadikimID ? { tzadikimID: item?.tzadikimID } : { mkmID: item?.mkmID }, item?.userFavorite)}><AiOutlineStar size={20} /></Button>
                                                }
                                                <div className="right_section">
                                                <Link
                                                    to={name === "Tzadikim"
                                                        ? `/category-detail/?tzadikimId=${item?.id}&cor=${item?.poi}`
                                                        : `/category-detail/?MkmId=${item?.id}&cor=${item?.poi}`
                                                    }
                                                    state={{
                                                        from: 'alongPreviousPoint',
                                                        data: location?.state?.data,
                                                        categoryName: name === "Tzadikim" ? 'tzadikim' : (item?.categoryId === 1 ? 'Cemeteries' : '')
                                                    }}
                                                    className='card_link'
                                                >
                                                    <CardTitle tag="h5" title={item?.title}>{item?.title}</CardTitle>
                                                </Link>
                                                    <Dropdown className="moreInfo" toggle={() => { setMenuOpen(!dropdownMenuOpen) }}
                                                        isOpen={dropdownMenuOpen}
                                                    >
                                                        <DropdownToggle>
                                                            <BiDotsVerticalRounded size={20} />
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            <DropdownItem >
                                                                <Link to={`/along-the-way-to-here/${item?.poi}`} state={{ categoryName: name, categoryTitle: categoryTitle, categoryIcon: categoryIcon }} className="breadcrumb_item1">Along the way to here</Link>
                                                            </DropdownItem>
                                                            <DropdownItem onClick={() => reportSuggestion(item?.title, item?.tzadikimID ? item?.tzadikimID : item?.mkmID)}>
                                                                Report suggestion
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </Dropdown>

                                                </div>
                                            </div>
                                            <CardText className="grid_text_le">{item?.stateY ? item?.stateY : item?.nfInfo}</CardText>
                                            <div className="card_bottom">
                                                <Button onClick={() => share(item?.tzadikimID ? item?.tzadikimID : item?.mkmID, item?.poi)}><FiShare2 size={20} /></Button>
                                                <div className="right_section">
                                                    <CardText>{item?.cityE + " " + item?.stateE}</CardText>
                                                    <MdLocationOn className="location_icon" size={18} />
                                                </div>
                                            </div>
                                            <div className="card_footer">
                                                <Link to={`/explore-near-by/${item?.poi}`} state={{ categoryName: name, categoryTitle: categoryTitle, categoryIcon: categoryIcon }} className="btn explore"><BiExitFullscreen className="explore_icon" />Explore Near By</Link>
                                                <Link
                                                    to={name === "Tzadikim"
                                                        ? `/category-detail/?tzadikimId=${item?.tzadikimID}&cor=${item?.poi}`
                                                        : `/category-detail/?MkmId=${item?.mkmID}&cor=${item?.poi}`
                                                    }
                                                    state={{ categoryName: name, categoryTitle: categoryTitle, categoryIcon: categoryIcon }}
                                                    className="btn viewmore"
                                                >
                                                    View More
                                                </Link>
                                                <Button className="btn addroute" onClick={() => addToRoute(item?.mkmID,item)}><FiBriefcase className="addroute_icon" />Add to Route</Button>
                                            </div>
                                        </Card></div>
                                    </InfoWindow>
                                ) : null}
                            </Marker>
                        </div>
                    )}
                </GoogleMap>
            ) : null}
        </div>
    )
}

export default MapView
